export default __webpack_public_path__ + "ee67964d1ff4529ef84b5088f5add9fe.svg";